import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningMaterialDetailsBuilder(apiClient: AxiosInstance) {
  return async function getLearningMaterialDetails(
    id: number
  ): Promise<ILearning.MaterialResponse | null> {
    try {
      const response = await apiClient.get(`/learning/api/materials/${id}/`);
      return response.data;
    } catch {
      return null;
    }
  };
}
